import { ArrowRight } from 'lucide-react';
import Icon from '@/components/base/Icon';
import useInView from '@/hooks/useInView';
import useNoHover from '@/hooks/useNoHover';

interface ServiceCardProps {
  icon: string;
  title: string;
  text: string;
  index: number;
}

export default function ServiceCard({ icon, title, text, index }: ServiceCardProps) {
  const noHover = useNoHover();
  const { ref, inView } = useInView<HTMLElement>(0.35);

  // On touch devices there is no hover, so light the card up on scroll instead:
  // when the card crosses the vertical centre of the viewport it "turns on".
  const revealed = noHover && inView;

  return (
    <article
      ref={ref}
      className={`group flex h-full flex-col rounded-lg border bg-background-50 p-6 transition-all duration-700 ease-out hover:-translate-y-1.5 hover:border-primary-300 ${
        revealed ? '-translate-y-1.5 border-primary-300' : 'translate-y-0 border-background-200'
      }`}
    >
      <div className="flex items-center justify-between">
        <div
          className={`flex h-14 w-14 items-center justify-center rounded-md transition-colors duration-500 group-hover:bg-primary-500 group-hover:text-background-50 dark:group-hover:text-foreground-950 ${
            revealed
              ? 'bg-primary-500 text-background-50 dark:text-foreground-950'
              : 'bg-primary-50 text-primary-700'
          }`}
        >
          <Icon name={icon} className="h-6 w-6" />
        </div>
        <span className="font-heading text-3xl font-extrabold text-background-300">
          {String(index + 1).padStart(2, '0')}
        </span>
      </div>
      <h3 className="mt-5 font-heading text-lg font-bold leading-snug text-foreground-950">{title}</h3>
      <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">{text}</p>
      <a
        href="#reunioes"
        className="mt-5 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap text-sm font-semibold text-primary-700 transition-colors duration-300 hover:text-primary-600"
      >
        Saber mais
        <ArrowRight
          className={`h-4 w-4 transition-transform duration-500 group-hover:translate-x-1 ${
            revealed ? 'translate-x-1' : 'translate-x-0'
          }`}
        />
      </a>
    </article>
  );
}